import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FestiveService } from '../../../../services/festive.service';

/** Two akash kandil lanterns hanging from the top edge of the header. */
@Component({
  selector: 'app-festive-lantern',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './festive-lantern.component.html',
  styleUrls: ['./festive-lantern.component.scss'],
})
export class FestiveLanternComponent {
  constructor(public festiveService: FestiveService) {}
}
